import FaUpload from '@mui/icons-material/FileUploadOutlined';
import { Avatar, Grid, Stack } from '@mui/material';
import { WsButton, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

interface IProfileImageUploader {
  profileImage?: string;
  onUpload: () => void;
  onRemove: () => void;
}

const ProfileImageUploader = ({ profileImage, onUpload, onRemove }: IProfileImageUploader) => (
  <Grid container alignItems="center" spacing={2} marginTop={1}>
    <Grid item xs={12}>
      <WsTypography variant={WsTypoVariants.BODY1} bold>
        Profile Picture
      </WsTypography>
    </Grid>
    <Grid item>
      <Avatar
        alt="Profile"
        src={profileImage}
        sx={{
          width: 50,
          height: 50,
          borderRadius: '50%',
        }}
      />
    </Grid>

    <Grid item xs>
      <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.SECONDARY}>
        File size less than 5 MB recommended. File format - JPG or PNG
      </WsTypography>
      <Stack direction="row" spacing={2}>
        <WsButton variant="outlined" startIcon={<FaUpload />} onClick={onUpload}>
          Upload Photo
        </WsButton>
        <WsButton variant="outlined" onClick={onRemove}>
          Remove Photo
        </WsButton>
      </Stack>
    </Grid>
  </Grid>
);

export default ProfileImageUploader;
